import { useEventBus } from '@vueuse/core';

const buses = new Map();

function getBus(event) {
  if (!buses.has(event)) {
    buses.set(event, useEventBus(event));
  }
  return buses.get(event);
}

/**
 * VueUse-based EventBus with Vue 2-compatible API.
 * Each event name gets its own dedicated bus instance.
 * To be replaced with a more robust solution when migrating to Vue 3.
 */
export const EventBus = {
  on(event, callback) {
    return getBus(event).on(callback);
  },
  off(event, callback) {
    getBus(event).off(callback);
  },
  emit(event, ...args) {
    getBus(event).emit(...args);
  },
};
